import { render, staticRenderFns } from "./SosPhysicalBtnConfig.vue?vue&type=template&id=02e1c7ad&"
import script from "./SosPhysicalBtnConfig.vue?vue&type=script&lang=ts&"
export * from "./SosPhysicalBtnConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports